import { Controller } from "@hotwired/stimulus";
import "./SectionItem.scss";

export default class SectionItemController extends Controller {
    // no behaviour so far
}
